let tabSection = document.querySelectorAll('.tabs-component');
tabSection.forEach(function (tabComponent) {
	
	function selectedTab(){
		let tabLinks = tabComponent.querySelectorAll('.tab-link');
		
		tabLinks.forEach(function (tabLink) {
			
			tabLink.addEventListener('click', function() {
				
				if (!this.classList.contains('active')) {
					let contentTabId = this.getAttribute('data-target');
					tabComponent.querySelector('.tab-link.active').classList.remove('active');
					tabComponent.setAttribute("aria-selected", false);
					this.classList.add('active');
					this.setAttribute("aria-selected", true);
					tabComponent.querySelector('.tab-content.active.show').classList.remove("active", "show");
					tabComponent.querySelector(contentTabId).classList.add("active");
					setTimeout(() => {
						tabComponent.querySelector(contentTabId).classList.add("show");
					}, 100)
				}
				
			})
		});
	}
	selectedTab();
});